import {useSelector} from 'react-redux';
import {useRPC} from './rpc';
import {useCallback} from 'react';
import {BaseModel} from '../types/control';
import {VirtualControlModel} from '../store/control/state';

const messageFromEntityList = (entityList: { name: string }[]) => {
    if (entityList.length === 0) {
        return null;
    } else if (entityList.length === 1) {
        return `${entityList[0].name}`;
    } else {
        return `${entityList[0].name} ve ${entityList.length - 1} tane daha kayıt`;
    }
};

export function useRelations() {
    const [rpc] = useRPC();
    const all = useSelector(state => state.control);

    return useCallback((id, type) => {
        return rpc.getRelations(id, type)
            .then(({data: relations}) => {
                const entityList = [];
                for (const relation of relations) {
                    if (relation.type === 'homepageItem') {
                        continue;
                    }

                    if (relation.type === 'stpUI') {
                        continue;
                    }

                    if (relation.type === "booster") {
                        continue
                    }

                    if (relation.type === "frameUI") {
                        continue
                    }

                    if (relation.should_update) {
                        continue;
                    }

                    const key = relation.type + 'List';
                    const relatedList = (all[key] as BaseModel[]);
                    const relatedEntity = relatedList.find(e => e.id === relation.relational_id);
                    if (relatedEntity == null) {
                        continue;
                    }

                    if (relatedEntity.registered_by_system === true) {
                        continue;
                    }

                    if (relation.type === 'virtualControl') {
                        const control = all.controlList.find(c => c.id === (relatedEntity as VirtualControlModel).control_id);
                        if (control == null) {
                            continue;
                        }

                        relatedEntity['name'] = `${control.name} sanal kontrol`;
                    }

                    entityList.push(relatedEntity);
                }

                const message = messageFromEntityList(entityList);
                const positiveButton = message == null ? undefined : {text: 'Hepsini Sil', timed: true};
                return [message, positiveButton];
            })
            .catch(() => null);
    }, [rpc, all]);
}
